import React from "react";
import { Span } from "@vp/swan";
import { useProductOptionContext } from "../../product-option/context";
export const SimpleTitleText = ({ showSelectedOptionText }) => {
    const { productOption, showFormErrors, selectedOptionText } = useProductOptionContext();
    const requiredAsterisk = "*";
    return (React.createElement(React.Fragment, null,
        productOption.name,
        productOption.isRequired && !showFormErrors && (React.createElement(Span, { "aria-hidden": "true", fontSkin: "body-standard" }, requiredAsterisk)),
        productOption.isRequired && showFormErrors && (React.createElement(Span, { textColor: "error", fontSkin: "body-standard" }, requiredAsterisk)),
        showSelectedOptionText && (React.createElement(Span, { "aria-hidden": "true", fontSkin: "body-standard", ml: "3" }, selectedOptionText))));
};
//# sourceMappingURL=simple-title-text.js.map